export default "__VITE_ASSET__6WG9$08X__"